import { useState, useEffect } from 'react';

/**
 * Hook para gerenciar tema claro/escuro com persistência em localStorage
 * e inicialização antes do React montar (sem flash)
 */
export function useTheme() {
  const [isDark, setIsDark] = useState(() => {
    // Inicializa a partir do localStorage ou preferência do sistema
    const stored = localStorage.getItem('nora-theme');
    if (stored) return stored === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Aplica o tema quando muda
  useEffect(() => {
    const theme = isDark ? 'dark' : 'light';
    localStorage.setItem('nora-theme', theme);
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : '');
  }, [isDark]);

  return { isDark, setIsDark };
}

/**
 * Inicializa o tema ANTES do React montar (evita flash)
 * Chame esta função no main.jsx antes de renderizar
 */
export function initializeTheme() {
  const stored = localStorage.getItem('nora-theme');
  const isDark = stored ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;

  if (isDark) {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
}
